<template>
  <div class="qintu-platform">
    <!-- 顶部导航栏 -->
    <topHeader />
    <!-- 产品展示区域 -->
    <div class="products-section">
      <div class="container">
        <div class="products-header">
          <div class="products-title">
            <h2 class="products-main-title">产品展示</h2>
            <span class="products-subtitle">PRODUCTS</span>
          </div>
          <div class="header-buttons">
            <!-- <button class="test-btn" @click="goToTestPage" title="测试FOSOFTECH组件">
              <span class="iconfont icon-sousuo"></span>
              测试组件1
            </button>
            <button class="test-btn" @click="goToTestPage2" title="测试FOSOFTECH组件">
              <span class="iconfont icon-sousuo"></span>
              测试组件2
            </button> -->
            <button class="all-products-btn" @click="goToProductList">
              全部产品
              <span class="iconfont icon-xiangyou3"></span>
            </button>
          </div>
        </div>

        <div class="products-grid">
          <div class="product-card" v-for="(product, index) in productShowcase" :key="index"
            @click="goToProduct(index)">
            <div class="product-image">
              <img :src="(isLoggedIn && isSoil) ? product.image : require('@/assets/mrt.png')" alt="产品图片" class="product-img">
              <span class="region-tag">{{ (isLoggedIn && isSoil) ? product.region : '******' }}</span>
              <button class="view-details-btn">查看详情</button>
            </div>

            <div class="product-info">
              <div class="product-title">{{ !isLoggedIn ? '信息登录后可见' : (isSoil ? product.title : '发布信息后可见') }}</div>
              <div class="product-description">{{ (isLoggedIn && isSoil) ? product.description : '*******************' }}</div>
              <div class="product-tags">
                <span class="product-type-tag" :class="(isLoggedIn && isSoil) && product.type === '找土' ? 'find-tag' : 'abandon-tag'">{{
                  (isLoggedIn && isSoil) ? product.type : '****' }}</span>
              </div>
              <div class="product-price">{{ (isLoggedIn && isSoil) ? product.price : '****' }}<span style="font-size: 12px;">{{ (isLoggedIn && isSoil) ? '方' : '****' }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="banner">
  
    <div class="banner-content">
      
      <div class="banner-image">
        <img src="@/assets/tu.png" alt="松软土" class="soil-image">
      </div>
    
      <div class="banner-text">
        <div class="strength-label">STRENGTH</div>
        <div class="bannerbox">
          <div style="display: flex;gap: 20px;">
            <div class="number">1</div>
            <div>
              <h3 class="soil-title">松软土</h3>    
              <div class="title-section">
                <p class="soil-subtitle">loose soil</p>
              </div>
             <div class="description">
              <p>松软土是天然含水量高、孔隙比大、压缩性强且抗剪强度低的细粒土,主要包括淤泥、淤泥质土、泥炭等。在土质学中泛指未团结的松散沉积物,由岩石风化,搬运形成,分布在地壳表层,按粒径。</p>
            </div>
            </div>
      
          </div>
        
          <div class="features">
            <p>水量大,压缩性高,承载力证</p>
          </div>
        </div>
      </div>
    </div>
 
</div> -->
    <!-- 主要内容区域 -->
    <main class="main-content">
      <div class="container findserve" style="display: flex;">
        <div style="flex: 7;">
          <div class="products-title">
            <h2 class="products-main-title" style="padding:20px 0">我要找土/弃土</h2>
          </div>
          <div class="content-wrapper">
            <!-- 左侧边栏 -->

            <div class="sidebar-container">
              <!-- 左侧导航栏 -->
              <div class="nav-sidebar">
                <div class="nav-item" @mouseenter="showContent('search')" :class="{ active: activeNav === 'search' }">
                  <span class="iconfont icon-kuaisu-shandian"></span>
                  <span class="nav-text">快速找土</span>
                </div>
                <div class="nav-item" @mouseenter="showContent('publish')" :class="{ active: activeNav === 'publish' }">
                  <span class="iconfont icon-fabuxinxi"></span>
                  <span class="nav-text">发布信息</span>
                </div>
                <div class="nav-item" @mouseenter="showContent('evaluate')"
                  :class="{ active: activeNav === 'evaluate' }">
                  <span class="iconfont icon-chaxuntiaodai-01"></span>
                  <span class="nav-text">土方评估</span>
                </div>
                <div class="nav-item" @mouseenter="showContent('customer')"
                  :class="{ active: activeNav === 'customer' }">
                  <span class="iconfont icon-kehu"></span>
                  <span class="nav-text">找土客户</span>
                </div>
              </div>

              <!-- 右侧内容区域 -->
              <div class="content-panel">
                <!-- 快速找地内容 -->
                <div v-show="activeNav === 'search'" class="content-section">
                  <div class="filter-section">
                    <div class="horizontal-filter-group">
                      <div class="filter-row">
                        <span class="filter-label">地区：</span>
                        <div class="filter-options">
                          <span v-for="region in regionOptions" :key="region"
                            :class="['filter-option', { active: selectedRegion === region }]"
                            @click="selectedRegion = region">
                            {{ region }}
                          </span>
                        </div>
                      </div>

                      <div class="filter-row">
                        <span class="filter-label">土方类型：</span>
                        <div class="filter-options">
                          <span v-for="type in landTypes" :key="type"
                            :class="['filter-option', { active: selectedLandType === type }]"
                            @click="selectedLandType = type">
                            {{ type }}
                          </span>
                        </div>
                      </div>

                      <div class="filter-row">
                        <span class="filter-label">体积：</span>
                        <div class="filter-options">
                          <span v-for="area in areaOptions" :key="area"
                            :class="['filter-option', { active: selectedArea === area }]" @click="selectedArea = area">
                            {{ area }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <button class="search-start-btn" @click="goToProductList">
                      <span class="iconfont icon-sousuo" style="margin-right: 8px;"></span>
                      开始找土
                    </button>
                  </div>

                  <!-- 地区选择 -->
                  <div class="tab-content">
                    <div class="tab-panel">
                      <div class="content-columns">
                        <div class="content-column">
                          <h4 class="column-title">地区</h4>
                          <div class="option-grid">
                            <div class="option-item" v-for="region in regions" :key="region"
                              @click="selectRegion(region)">
                              {{ region }}
                            </div>
                          </div>
                        </div>

                        <div class="content-column">
                          <h4 class="column-title">类型</h4>
                          <div class="option-grid">
                            <div class="option-item" v-for="type in landTypes" :key="type" @click="selectType(type)">
                              {{ type }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 发布信息内容 -->
                <div v-show="activeNav === 'publish'" class="content-section">
                  <div class="publish-form">
                    <h3 class="form-title">选择信息类型,快速找到买家、卖家!</h3>
                    <div class="horizontal-filter-group">
                      <div class="filter-row">
                        <span class="filter-label">信息类型：</span>
                        <div class="filter-options">
                          <span v-for="pubType in publishTypes" :key="pubType"
                            :class="['filter-option', { active: selectedPublishType === pubType }]"
                            @click="selectedPublishType = pubType">
                            {{ pubType }}
                          </span>
                        </div>
                      </div>

                      <div class="filter-row">
                        <span class="filter-label">地区：</span>
                        <div class="filter-options">
                          <span v-for="city in regionOptions" :key="city"
                            :class="['filter-option', { active: selectedCity === city }]" @click="selectedCity = city">
                            {{ city }}
                          </span>
                        </div>
                      </div>

                      <div class="filter-row">
                        <span class="filter-label">土方类型：</span>
                        <div class="filter-options">
                          <span v-for="type in landTypes" :key="type"
                            :class="['filter-option', { active: selectedPublishLandType === type }]"
                            @click="selectedPublishLandType = type">
                            {{ type }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <button class="search-start-btn" @click="goToPublish">
                      <span class="iconfont icon-fabu" style="margin-right: 8px;"></span>
                      免费发布信息
                    </button>
                  </div>
                </div>

                <!-- 土评估内容 -->
                <div v-show="activeNav === 'evaluate'" class="content-section">
                  <div class="evaluate-form">
                    <div class="form-reminder">温馨提示：为您计算该土当前市场参考价格</div>
                    <div class="horizontal-filter-group">
                      <div class="filter-row">
                        <span class="filter-label">地区：</span>
                        <div class="filter-options">
                          <span v-for="city in regionOptions" :key="city"
                            :class="['filter-option', { active: selectedEvaluateCity === city }]"
                            @click="selectedEvaluateCity = city">
                            {{ city }}
                          </span>
                        </div>
                      </div>

                      <div class="filter-row">
                        <span class="filter-label">土方类型：</span>
                        <div class="filter-options">
                          <span v-for="type in landTypes" :key="type"
                            :class="['filter-option', { active: selectedEvaluateType === type }]"
                            @click="selectedEvaluateType = type">
                            {{ type }}
                          </span>
                        </div>
                      </div>

                      <div class="filter-row">
                        <span class="filter-label">土方体积：</span>
                        <input type="text" v-model="landArea" placeholder="请输入土体积" class="filter-input">
                      </div>


                    </div>
                    <button class="search-start-btn">
                      <span class="iconfont icon-jisuanqi" style="margin-right: 8px;"></span>
                      免费评估土
                    </button>
                  </div>
                </div>

                <!-- 找地客户内容 -->
                <div v-show="activeNav === 'customer'" class="content-section">
                  <div class="filter-section">
                    <div class="horizontal-filter-group">
                      <div class="filter-row">
                        <span class="filter-label">地区：</span>
                        <div class="filter-options">
                          <span v-for="region in regionOptions" :key="region"
                            :class="['filter-option', { active: selectedCustomerRegion === region }]"
                            @click="selectedCustomerRegion = region">
                            {{ region }}
                          </span>
                        </div>
                      </div>

                      <div class="filter-row">
                        <span class="filter-label">土方类型：</span>
                        <div class="filter-options">
                          <span v-for="type in landTypes" :key="type"
                            :class="['filter-option', { active: selectedCustomerType === type }]"
                            @click="selectedCustomerType = type">
                            {{ type }}
                          </span>
                        </div>
                      </div>

                      <div class="filter-row">
                        <span class="filter-label">体积：</span>
                        <div class="filter-options">
                          <span v-for="area in areaOptions" :key="area"
                            :class="['filter-option', { active: selectedCustomerArea === area }]"
                            @click="selectedCustomerArea = area">
                            {{ area }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <button class="search-start-btn">
                      <span class="iconfont icon-kehu" style="margin-right: 8px;"></span>
                      找客户
                    </button>
                  </div>

                  <!-- 地区选择 -->
                  <div class="tab-content">
                    <div class="tab-panel">
                      <div class="content-columns">
                        <div class="content-column">
                          <h4 class="column-title">地区</h4>
                          <div class="option-grid">
                            <div class="option-item" v-for="region in regions" :key="region"
                              @click="selectRegion(region)">
                              {{ region }}
                            </div>
                          </div>
                        </div>

                        <div class="content-column">
                          <h4 class="column-title">类型</h4>
                          <div class="option-grid">
                            <div class="option-item" v-for="type in landTypes" :key="type" @click="selectType(type)">
                              {{ type }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- 右侧轮播图 -->
            <!-- <div class="right-section" style="flex:4">
            <div class="carousel-section">
              <div class="carousel-container">
                <div class="carousel-wrapper" :style="{ transform: `translateX(-${currentSlide * 100}%)` }">
                  <div class="carousel-slide" v-for="(slide, index) in slides" :key="index">
                    <div class="slide-content">
                      <div class="slide-image">
                        <img :src="slide.image" alt="轮播图" class="carousel-img">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          </div>
        </div>
        <div style="flex: 3;">
          <div class="products-title">
            <h2 class="products-main-title" style="padding:20px 0;margin-left:20px">服务流程</h2>
          </div>
          <div class="service-flow-section">
            <div class="flow-grid" style="display: flex;flex-direction: column;">
              <div class="serve-flow-item">
                <!-- 左上角：信息注册与录入 -->
                <div class="flow-item hover-effect">
                  <div class="flow-icon">
                    <span class="flow-icon-emoji"><img src="../assets/s1.png" alt=""></span>
                  </div>
                  <div class="flow-text">信息注册与录入(供需双方)</div>
                </div>
                <div class="iconfont icon-jiantou_yemian_xiangyou hover-icon"></div>
                <!-- 右上角：智能匹配与筛选 -->
                <div class="flow-item hover-effect">
                  <div class="flow-icon">
                    <span class="flow-icon-emoji"><img src="../assets/s2.png" alt=""></span>
                  </div>
                  <div class="flow-text">智能匹配与筛选</div>
                </div>
              </div>
              <div class="iconfont icon-jiantou_yemian_xiangxia iconfontright " ></div>
              <div class="serve-flow-item">
                <!-- 左下角：运输监管与利用闭环 -->
                <div class="flow-item hover-effect">
                  <div class="flow-icon">
                    <span class="flow-icon-emoji"><img src="../assets/s3.png" alt=""></span>
                  </div>
                  <div class="flow-text">运输监管与利用闭环</div>
                </div>
                <div class="iconfont icon-jiantou_yemian_xiangzuo hover-icon"></div>
                <!-- 右下角：线下核验与签约 -->
                <div class="flow-item hover-effect">
                  <div class="flow-icon">
                    <span class="flow-icon-emoji"><img src="../assets/s4.png" alt=""></span>
                  </div>
                  <div class="flow-text">线下核验与签约</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- <div class="service-process-section">
      <div class="container">
        <div class="process-header">
          <h2 class="process-title">服务流程</h2>
          <div class="process-subtitle">
            <span class="chinese-text">SERVICE PROCESS</span>
          </div>
        </div>

        <div class="process-steps">
          <div class="step-item">
            <div class="step-icon">
              <span class="iconfont icon-yurejiaohuan"></span>
            </div>
            <div class="step-text">信息注册与录入（供需双方）</div>
          </div>

          <div class="step-arrow">
            <span class="iconfont icon-youjiantou"></span>
          </div>

          <div class="step-item">
            <div class="step-icon">
              <span class="iconfont icon-zhaobiaofangan"></span>
            </div>
            <div class="step-text">智能匹配与筛选</div>
          </div>

          <div class="step-arrow">
            <span class="iconfont icon-youjiantou"></span>
          </div>

          <div class="step-item">
            <div class="step-icon">
              <span class="iconfont icon-yurehuishou"></span>
            </div>
            <div class="step-text">线下核验与签约</div>
          </div>

          <div class="step-arrow">
            <span class="iconfont icon-youjiantou"></span>
          </div>

          <div class="step-item">
            <div class="step-icon">
              <span class="iconfont icon-weibiaoti-1-04"></span>
            </div>
            <div class="step-text">运输监管与利用闭环</div>
          </div>

          <div class="step-arrow">
        <span class="iconfont icon-youjiantou"></span>
      </div>
      
      <div class="step-item">
        <div class="step-icon">
          <span class="iconfont icon-LOT"></span>
        </div>
        <div class="step-text">运营保障5g物联网</div>
      </div> 

          <div class="contact-button">
        <button class="contact-btn">
          联系我们
          <span class="iconfont icon-xiangyou3"></span>
        </button>
      </div>
        </div>
      </div>
    </div> -->
    <!-- 经典案例 -->
    <div class="products-section" style="background-color: #f5f4f9;">
      <div class="container">
        <div class="products-header">
          <div class="products-title">
            <h2 class="products-main-title">成功案例</h2>
            <span class="products-subtitle">TYPICAL CASE</span>
          </div>
          <button class="all-products-btn" @click="goToProductList2">
            查看详情
            <span class="iconfont icon-xiangyou3"></span>
          </button>
        </div>

        <div class="case-showcase-grid">
          <div class="case-showcase-item" v-for="(product, index) in productShowcase1.slice(0, 3)" :key="index"
            @click="goToProduct(product)">
            <div class="case-showcase-image-container">
                <img :src="(isLoggedIn && isSoil) ? product.image : require('@/assets/mrt.png')" alt="产品图片" class="case-showcase-image">
              </div>
            <div class="case-showcase-content">
              <div class="case-showcase-title">{{ !isLoggedIn ? '信息登录后可见' : (isSoil ? product.description : '发布信息后可见') }}</div>
              <div class="case-showcase-details">
                <div class="case-showcase-cost"><span class="case-showcase-application-text">{{ (isLoggedIn && isSoil) ? '找土' : '****' }}</span>：<span
                    class="case-showcase-price">{{ (isLoggedIn && isSoil) ? product.price : '****' }}</span></div>
                <div class="case-showcase-application"><span class="case-showcase-application-text">{{ (isLoggedIn && isSoil) ? '应用处' : '****' }}</span>：{{ (isLoggedIn && isSoil) ? '公路用土' : '****' }}
                </div>
              </div>
              <button class="case-showcase-action-btn">>></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 水保资讯模块 -->
    <div class="news-center-section">
      <div class="container">
        <div class="news-center-header">
          <!-- Tab切换 -->
          <div class="tab-container">
            <button class="tab-item" :class="{ 'tab-item-active': activeTab === 'news' }" @click="switchTab('news')">水保资讯</button>
            <button class="tab-item" :class="{ 'tab-item-active': activeTab === 'law' }" @click="switchTab('law')">法律法规</button>
            <button class="tab-item" :class="{ 'tab-item-active': activeTab === 'science' }" @click="switchTab('science')">技术规范</button>
          </div>
          <!-- <div class="news-center-title">
            <h2 class="products-main-title">水保动态</h2>
            <span class="products-subtitle">NEWS CENTER</span>
          </div> -->
          <!-- <div class="news-center-tabs">
            <button class="news-tab news-tab-active" @click="goToZixunList('company')">公司新闻<span
                class="iconfont icon-xiangyou3"></span></button>
            <button class="news-tab hangye" @click="goToZixunList('industry')">行业新闻<span
                class="iconfont icon-xiangyou3"></span></button>
            
          </div> -->
        </div>

        <div class="news-center-content">
         
           <!-- 右侧资讯列表 -->
          <div class="news-center-list">
            <div style="display: flex; justify-content: flex-end;">
              <div style="width: 100px;" class="all-products-btn"  @click="goToZixunList(activeTab)">查看详情<span class="iconfont icon-xiangyou3"></span></div>
            </div>
            <div class="news-center-item" v-for="(news, index) in serviceNews" :key="index"
              @click="goToNewsDetail(news.id)">
              <div class="news-center-item-content">
                <div class="news-center-item-title">• {{ news.title }}</div>
                <div class="news-center-item-date-text">{{ news.date }} </div>
              </div>
            </div>
          </div>
          <!-- 左侧大图 -->
          <div class="news-center-featured">
            <img src="@/assets/zx.png" alt="水保图片" class="news-center-main-image">
            <!-- <div class="news-center-overlay">
              <div class="news-center-date">
                <div class="news-center-day">29</div>
                <div class="news-center-month">2025-02</div>
              </div>
              <div class="news-center-featured-title">水利部水土保持监测中心专题开展丹江口库区及上游流域水土保持监测技术研讨</div>
            </div> -->
          </div>

         
        </div>
      </div>
    </div>
    <!-- 页脚 -->
    <footer class="site-footer">
      <!-- 顶部绿色分类栏 -->
      <div class="footer-categories">
        <div class="container">
          <div class="categories-bar">
            <span class="category-icon iconfont icon-guanlian"></span>
            <span class="category-label">相关链接</span>
            <a href="http://swcc.mwr.gov.cn/" class="category-link">水土保持司</a>
            <a href="http://www.swcc.org.cn/" class="category-link">水土保持生态建设网</a>
          </div>
        </div>
      </div>

      <!-- 主要内容区域 -->
      <div class="footer-main">
        <div class="container">
          <div class="footer-content">
            <!-- 左侧logo和二维码 -->
            <div class="footer-left">
              <div class="footer-logo">
                <span class="logo1"><img src="@/assets/logo1.png" alt=""></span>
                <img src="@/assets/logo2.png" alt="" class="qtzp-logo">
              </div>
             <div class="footermain">
              <!-- <div>主办单位：秦皇岛市数政局</div> -->
              <div>技术支持单位：秦皇岛市大数据有限公司</div>
              <div>建议您使用IE10 及以上版本、Chrome、360浏览器(极速模式)浏览器浏览本网站</div>
              <div class="footermain-item">域名备案号：<a href="https://beian.miit.gov.cn/" target="_blank" >冀ICP备2025101797号-4</a></div>
              <div class="footermain-item">冀公网安备：<a href="https://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" >13030202003994号</a></div>
            </div>
            </div>

      
          </div>
        </div>
      </div>
    </footer>
    
    <!-- 发布信息弹窗 -->
    <div v-if="showPublishModal" class="publish-modal-overlay" @click.self="closePublishModal">
      <div class="publish-modal-container">
        <div class="publish-modal-header">
          <h3>发布土方信息</h3>
          <button class="close-btn" @click="closePublishModal">×</button>
        </div>
        <div class="publish-modal-content">
          <Publish 
            :val="publishModalVal"
            :initial-form-data="publishInitialData"
            @close="closePublishModal"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topHeader from './top-Header.vue';
import Publish from './publish.vue';
import { getSoilInfoList, getConsultInfoList } from '@/api/user'

export default {
  name: "QintuPlatform",
  components: {
    topHeader,
    Publish
  },
  data() {
    return {
      // 导航相关数据
      activeNav: 'search',
      // Tab切换状态
      activeTab: 'news',
      // 登录状态（实际项目中应该从全局状态或localStorage获取）
      isLoggedIn: false,
      // 土方平台权限状态
      isSoil: localStorage.getItem('isSoil') ,
      regions: [
        '全秦皇岛', '海港区', '开发区', '抚宁区', '北戴河区', '北戴河新区',
        '山海关区', '青龙县', '卢龙县', '昌黎县'
      ],
      landTypes: [
        '表土','松软土', '普通土', '坚土', '砂砾坚土',
        '软石','次坚石', '坚石','特坚石', '回填土', '外运土方',
        '借方土', '常规土方', '特殊土方'
      ],
      // 横向筛选选项
      regionOptions: ['全秦皇岛', '海港区', '开发区', '抚宁区', '北戴河区', '北戴河新区',
        '山海关区', '青龙县', '卢龙县', '昌黎县'],
      areaOptions: ['10万立方以下', '10-50万立方', '50-100万立方', '100万立方以上'],
      cityOptions: ['全秦皇岛', '海港区', '开发区', '抚宁区', '北戴河区', '北戴河新区',
        '山海关区', '青龙县', '卢龙县', '昌黎县'],
      publishTypes: ['发布供应', '发布需求'],
      // 快速找土选中状态
      selectedRegion: '',
      selectedLandType: '',
      selectedArea: '',
      // 发布信息选中状态
      selectedPublishType: '',
      selectedCity: '',
      selectedPublishLandType: '',
      // 发布弹窗相关
      showPublishModal: false,
      publishModalVal: '0',
      publishInitialData: {},
      // 土方评估选中状态
      selectedEvaluateCity: '',
      selectedEvaluateType: '',
      landArea: '',
      transferYears: '',
      // 找地客户选中状态
      selectedCustomerRegion: '',
      selectedCustomerType: '',
      selectedCustomerArea: '',

      // 首页产品展示（接口获取）
      productShowcase: [],
      // 首页成功案例（接口获取）
      productShowcase1: [],
      // 产品数据
      products: [
        {
          image: require('@/assets/sjt/1.png'),
          price: '30000.00',
          volume: '30m³',
          location: '海港区生态谷小区北侧',
          code: ''
        },
        {
          image: require('@/assets/sjt/2.png'),
          price: '30000.00',
          volume: '30m³',
          location: '海港区生态谷小区北侧',
          code: ''
        },
        {
          image: require('@/assets/sjt/3.png'),
          price: '30000.00',
          volume: '30m³',
          location: '海港区生态谷小区北侧',
          code: ''
        },
        {
          image: require('@/assets/sjt/4.png'),
          price: '30000.00',
          volume: '30m³',
          location: '海港区生态谷小区北侧',
          code: ''
        },
        {
          image: require('@/assets/sjt/5.png'),
          price: '30000.00',
          volume: '30m³',
          location: '海港区生态谷小区北侧',
        },
        {
          image: require('@/assets/sjt/6.png'),
          price: '30000.00',
          volume: '30m³',
          location: '海港区生态谷小区北侧',
        },
        {
          image: require('@/assets/sjt/7.png'),
          price: '30000.00',
          volume: '30m³',
          location: '海港区生态谷小区北侧',
        },
        {
          image: require('@/assets/sjt/8.png'),
          price: '30000.00',
          volume: '30m³',
          location: '海港区生态谷小区北侧',
        },
      ],

      // 水保资讯数据（从接口获取）
      serviceNews: [],
      baseNews: [],
      // 法律法规（从接口获取）
      lawNews: [],
      // 技术规范（从接口获取）
      scienceNews: [],

      // 轮播图相关数据
      currentSlide: 0,
      slides: [
        {
          image: require('@/assets/images/td1.png'),
        },
        {
          image: require('@/assets/images/td2.png'),
        },
        {
          image: require('@/assets/images/td3.png'),
        }
      ],
      showProductDetail: false,
      selectedProduct: {},
      // storage 事件监听器引用
      storageListener: null
    };
  },
  methods: {
    // 更新登录状态方法（供登录成功后调用）
    updateLoginStatus(isSuccess) {
      const wasLoggedIn = this.isLoggedIn;
      this.isLoggedIn = isSuccess;
      localStorage.setItem('isLoggedIn', isSuccess.toString());
      
      // 如果从未登录变为已登录，刷新首页数据
      if (!wasLoggedIn && isSuccess) {
        console.log('登录成功，刷新首页数据');
        // 刷新产品展示数据
        this.fetchHomeProducts();
        // 刷新成功案例数据
        this.fetchHomeCases();
        // 刷新资讯列表数据（如果当前在首页）
        if (this.$route.path === '/') {
          this.fetchConsultList('news');
          // 如果当前选中的是其他tab，也刷新对应的数据
          if (this.activeTab === 'law') {
            this.fetchConsultList('law');
          } else if (this.activeTab === 'science') {
            this.fetchConsultList('science');
          }
        }
      }
    },
    
    goToPublish() {
      // 检查登录状态
      if (!this.isLoggedIn) {
        // 未登录，显示登录弹窗
        if (window.showLoginDialog) {
          window.showLoginDialog();
        } else {
          alert('请先登录');
        }
        return;
      }
      
      // 构建初始表单数据
      const initialData = {}
      
      // 信息类型映射：发布供应 -> 找土(1), 发布需求 -> 弃土(0)
      if (this.selectedPublishType === '发布供应') {
        this.publishModalVal = '0' // 显示选择按钮
        initialData.infoType = '1'
      } else if (this.selectedPublishType === '发布需求') {
        this.publishModalVal = '0' // 显示选择按钮
        initialData.infoType = '0'
      } else {
        this.publishModalVal = '0' // 默认显示选择按钮
      }
      
      // 地区：过滤掉'全秦皇岛'，因为发布页面不支持
      if (this.selectedCity && this.selectedCity !== '全秦皇岛') {
        initialData.region = this.selectedCity
      }
      
      // 土方类型
      if (this.selectedPublishLandType) {
        initialData.soilType = this.selectedPublishLandType
      }
      
      // 设置初始数据并显示弹窗
      this.publishInitialData = initialData
      this.showPublishModal = true
    },
    closePublishModal() {
      this.showPublishModal = false
      // 清空初始数据
      this.publishInitialData = {}
    },
    goToTestPage() {
      this.$router.push('/fosoftech-test')
    },
    goToTestPage2() {
      this.$router.push('/fosoftech-test2')
    },
    goToProductList() {
      // 检查土方平台权限
      if (this.isLoggedIn && this.isSoil === false) {
        // 如果已登录但 isSoil 为 false，显示发布土方弹窗
        this.showPublishModal = true;
        this.publishModalVal = '0';
        this.publishInitialData = {};
        return;
      }
      this.$router.push('/findlist');
    },
    goToProductList2() {
      // 检查土方平台权限
      if (this.isLoggedIn && this.isSoil === false) {
        // 如果已登录但 isSoil 为 false，显示发布土方弹窗
        this.showPublishModal = true;
        this.publishModalVal = '0';
        this.publishInitialData = {};
        return;
      }
      this.$router.push('/success');
    },
    goToProduct(itemOrIndex) {
      // 检查土方平台权限
      if (this.isLoggedIn && this.isSoil === false) {
        // 如果已登录但 isSoil 为 false，显示发布土方弹窗
        this.showPublishModal = true;
        this.publishModalVal = '0';
        this.publishInitialData = {};
        return;
      }
      
      // 支持传入 item.id 或 index
      let productId = '';
      let fromParam = 'search'; // 默认来源为找土
      
      if (typeof itemOrIndex === 'object' && itemOrIndex) {
        productId = itemOrIndex.id;
        // 判断是否来自成功案例（检查是否在 productShowcase1 中）
        const isFromSuccess = this.productShowcase1.some(item => item.id === productId);
        if (isFromSuccess) {
          fromParam = 'success'; // 从成功案例进入
        }
      } else if (typeof itemOrIndex === 'number') {
        const item = this.productShowcase[itemOrIndex];
        productId = item && item.id;
        // 产品展示默认来源为找土
      }
      if (!productId) return;
      this.$router.push({ path: `/product/${productId}`, query: { from: fromParam } });
    },
    async fetchHomeProducts() {
      try {
        const res = await getSoilInfoList({ pageNum: 1, pageSize: 5 });
        const list = (res && res.rows) || res?.data || [];
        this.productShowcase = (list || []).map(item => {
          // 从fileName拼接完整路径
          const imageBaseUrl = 'https://qtzp.qhdbigdata.com/qtzp-api/upload/';
          const firstFileName = (item.imageUrl || '')
            .split(',')
            .map(s => s && s.trim())
            .filter(Boolean)[0];
          const firstImg = firstFileName ? (firstFileName.startsWith('http') ? firstFileName : imageBaseUrl + firstFileName) : '';
          return {
            id: item.id,
            image: firstImg || require('@/assets/sjt/1.png'),
            title: item.title || '未命名',
            description: item.address || item.region || '',
            region: item.region || '',
            type: (item.infoType === 1 || item.infoType === '1') ? '找土' : '弃土',
            price: item.volume ? String(item.volume) : ''
          };
        }).slice(0, 5);
      } catch (e) {
        console.error('获取首页产品展示失败', e);
      }
    },
    async fetchHomeCases() {
      try {
        const res = await getSoilInfoList({ pageNum: 1, pageSize: 3, infoStatus: 2 });
        const list = (res && res.rows) || res?.data || [];
        const mapped = (list || []).map(item => {
          // 从fileName拼接完整路径
          const imageBaseUrl = 'https://qtzp.qhdbigdata.com/qtzp-api/upload/';
          const firstFileName = (item.imageUrl || '')
            .split(',')
            .map(s => s && s.trim())
            .filter(Boolean)[0];
          const firstImg = firstFileName ? (firstFileName.startsWith('http') ? firstFileName : imageBaseUrl + firstFileName) : '';
          return {
            id: item.id,
            image: firstImg || require('@/assets/sjt/9.png'),
            description: item.title || (item.address || ''),
            price: (item.volume ? `${item.volume}${item.volumeUnit || ''}` : '')
          };
        });
        if (mapped.length === 0) {
          // 接口无数据时的兜底展示
          this.productShowcase1 = [
            { id: 'm1', image: require('@/assets/sjt/9.png'), description: '青龙满族自治县10立方公路用土', price: '10立方' },
            { id: 'm2', image: require('@/assets/sjt/10.png'), description: '抚宁区绿化工程回填土', price: '15立方' },
            { id: 'm3', image: require('@/assets/sjt/11.png'), description: '昌黎县市政工程弃土案例', price: '20立方' }
          ];
        } else {
          // 确保只显示3个成功案例
          this.productShowcase1 = mapped.slice(0, 3);
        }
      } catch (e) {
        console.error('获取首页成功案例失败', e);
        // 异常情况下也展示兜底数据
        this.productShowcase1 = [
          { id: 'm1', image: require('@/assets/sjt/9.png'), description: '青龙满族自治县10立方公路用土', price: '10立方' },
          { id: 'm2', image: require('@/assets/sjt/10.png'), description: '抚宁区绿化工程回填土', price: '15立方' },
          { id: 'm3', image: require('@/assets/sjt/11.png'), description: '昌黎县市政工程弃土案例', price: '20立方' }
        ];
      }
    },

    // 跳转到资讯详情页
    goToNewsDetail(id) {
      if (!id) return
      
      if(this.activeTab === 'news') {
        this.$router.push({
          path: '/zixunDetail',
          query: { id }
        });
      } else if(this.activeTab === 'law') {
        this.$router.push({
          path: '/fawDetail',
          query: { id }
        });
      } else if(this.activeTab === 'science') {
        this.$router.push({
          path: '/techSpecDetail',
          query: { id }
        });
      }
    },

    // 显示内容方法
    showContent(nav) {
      this.activeNav = nav;
    },

    // 地区选择方法
    selectRegion(region) {
      console.log('选择地区:', region);
    },

    // 类型选择方法
    selectType(type) {
      console.log('选择类型:', type);
    },

    // 轮播图方法
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    },
    
    // Tab切换方法
    switchTab(tab) {
      this.activeTab = tab;
      // 根据tab类型切换右侧列表数据
      if (tab === 'news') {
        // 水保资讯
        this.serviceNews = this.baseNews;
      } else if (tab === 'law') {
        this.serviceNews = this.lawNews;
      } else if (tab === 'science') {
        this.serviceNews = this.scienceNews;
      }
      // 如果当前tab的数据为空，则重新获取
      if ((tab === 'news' && this.baseNews.length === 0) ||
          (tab === 'law' && this.lawNews.length === 0) ||
          (tab === 'science' && this.scienceNews.length === 0)) {
        this.fetchConsultList(tab);
      }
    },
    
    // 获取咨询、法规、规范列表
    async fetchConsultList(type) {
      try {
        let typeParam = '0'; // 默认水保咨询
        if (type === 'law') {
          typeParam = '1'; // 法律法规
        } else if (type === 'science') {
          typeParam = '2'; // 技术规范
        }
        
        const params = {
          type: typeParam,
          pageNum: '1',
          pageSize: '8' // 首页最多显示8条
        }
        
        const res = await getConsultInfoList(params)
        const list = (res && res.rows) || res?.data?.rows || res?.data || []
        
        const newsList = (list || []).map(item => {
          const dateStr = item.publishTime || item.createTime || ''
          let formattedDate = ''
          if (dateStr) {
            const date = new Date(dateStr)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            formattedDate = `${year}-${month}-${day}`
          }
          
          return {
            id: item.id,
            title: item.title || item.name || '未命名',
            source: item.source || '',
            date: formattedDate
          }
        }).slice(0, 7) // 确保最多只显示8条
        
        // 根据类型存储到对应的数据中
        if (type === 'news') {
          this.baseNews = newsList
          if (this.activeTab === 'news') {
            this.serviceNews = this.baseNews
          }
        } else if (type === 'law') {
          this.lawNews = newsList
          if (this.activeTab === 'law') {
            this.serviceNews = this.lawNews
          }
        } else if (type === 'science') {
          this.scienceNews = newsList
          if (this.activeTab === 'science') {
            this.serviceNews = this.scienceNews
          }
        }
      } catch (error) {
        console.error('获取列表失败:', error)
      }
    },

    prevSlide() {
      this.currentSlide = this.currentSlide === 0 ? this.slides.length - 1 : this.currentSlide - 1;
    },

    goToSlide(index) {
      this.currentSlide = index;
    },

    goToZixunList(type) { 
      if (type === 'news' || type === 'company') {
        this.$router.push('/zixunlist');
      } else if (type === 'law') {
        this.$router.push('/faw');
      } else if (type === 'science') {
        this.$router.push('/techSpec');
      }
    }
  },

  // 自动轮播
  mounted() {
    // 从localStorage获取登录状态
    this.isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    // 从localStorage获取土方平台权限状态
    const storedIsSoil = localStorage.getItem('isSoil');
    if (storedIsSoil !== null) {
      this.isSoil = storedIsSoil === 'true';
    }
    
    // 监听登录状态变化
    this.storageListener = (e) => {
      if (e.key === 'isLoggedIn') {
        const wasLoggedIn = this.isLoggedIn;
        const newLoginStatus = e.newValue === 'true';
        this.isLoggedIn = newLoginStatus;
        
        // 如果从未登录变为已登录，刷新首页数据
        if (!wasLoggedIn && newLoginStatus && this.$route.path === '/') {
          console.log('登录状态变化，刷新首页数据');
          this.fetchHomeProducts();
          this.fetchHomeCases();
          this.fetchConsultList('news');
          if (this.activeTab === 'law') {
            this.fetchConsultList('law');
          } else if (this.activeTab === 'science') {
            this.fetchConsultList('science');
          }
        }
      }
      // 监听 isSoil 状态变化
      if (e.key === 'isSoil') {
        this.isSoil = e.newValue === 'true';
      }
    };
    window.addEventListener('storage', this.storageListener);
    
    // 获取首页数据
    this.fetchHomeProducts();
    this.fetchHomeCases();
    // 获取水保资讯数据（默认显示）
    this.fetchConsultList('news');
    // 将updateLoginStatus方法挂载到window上，以便topHeader组件调用
    window.updateQintuLoginStatus = this.updateLoginStatus.bind(this);
    
    // 自动轮播
    setInterval(() => {
      this.nextSlide();
    }, 5000);

    // 拉取首页展示数据
    this.fetchHomeProducts();
    this.fetchHomeCases();
  },
  
  // 组件卸载前清理事件监听和全局方法
  beforeUnmount() {
    if (this.storageListener) {
      window.removeEventListener('storage', this.storageListener);
    }
    window.updateQintuLoginStatus = null;
  }
};
</script>

<style scoped lang="scss">
/* 引入iconfont.css */
@import url('../assets/iconfont.css');

.qintu-platform {
  min-height: 100vh;
  background-color: #f5f5f5;
}

/* 产品展示区域样式 */
.products-section {
  background-color: white;
  padding: 20px 0;
}

.header-buttons {
  display: flex;
  gap: 12px;
  align-items: center;
}

.test-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #422C27 0%, #6B4E3D 100%);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(66, 44, 39, 0.3);
}

.test-btn:hover {
  background: linear-gradient(135deg, #E4CEC2 0%, #A6886B 100%);
  color: #333;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(66, 44, 39, 0.4);
}

.test-btn .iconfont {
  font-size: 16px;
}

.products-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.products-title {
  display: flex;
  align-items: center;
  gap: 15px;
}

.products-main-title {
  font-size: 24px;
  font-weight: bold;
  color: #422C27;
  margin: 0;
}

.products-subtitle {
  font-size: 14px;
  color: #422C27;
}

.all-products-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  color: #422C27;
  border: none;
  padding: 12px 20px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  background-color: transparent;
  transition: background-color 0.3s;
   
}

.all-products-btn:hover {
   color: #333;
  background-color: #E4CEC2;
}

.all-products-btn .iconfont {
  font-size: 18px;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

.product-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: visible;
  background-color: white;
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
}

.product-card:hover {
 
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border: 2px solid #422C27;
}

.product-card:hover .view-details-btn {
  background-color: #E4CEC2;
   color: #333;
}

.product-image {
  height: 200px;
  overflow: hidden;
  position: relative;
  border-radius: 8px 8px 0 0;
}

.product-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.product-card:hover .product-img {
  transform: scale(1.05);
}

.region-tag {
  position: absolute;
  top: 10px;
  left: 10px;
  background: linear-gradient(135deg, #FF6B6B 0%, #FF4757 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  box-shadow: 0 2px 6px rgba(255, 71, 87, 0.3);
}

.product-info {
  padding: 15px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* height: 160px; */
}

.product-title {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-description {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-tags {
  display: flex;
  gap: 8px;
  align-items: center;
}

.product-type-tag {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: bold;
  border: 1px solid;
}

.find-tag {
  background: rgba(255, 161, 0, 0.1);
  border-color: rgba(255, 123, 0, 0.5);
  color: #FF7B00;
}

.abandon-tag {
  background: rgba(0, 113, 215, 0.1);
  border-color: rgba(0, 113, 215, 0.5);
  color: #0071D7;
}

.product-price {
  font-size: 20px;
  font-weight: bold;
  color: #FF4757;
  margin-top: auto;
}

.view-details-btn {
  position: absolute;
  bottom: 10px;
  right: 0;
  background-color: #422C27;
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 12px 0 0 12px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: bold;
  z-index: 10;
}

.view-details-btn:hover {
  background-color: #E4CEC2;
  // padding-right: 18px;
   color: #333;
}

/* 横幅区域样式 */
.banner {
  background-color: white;
  padding: 40px 0;
}

.banner-content {
  display: flex;
  align-items: center;
  gap: 0;
  min-height: 400px;
}

.banner-image {
  flex: 1;
  height: 400px;
  overflow: hidden;
}

.soil-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-text {
  flex: 1;
  background-color: #422C27;
  height: 400px;
  position: relative;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.strength-label {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 60px;
  font-weight: bold;
  color: #4a9d8c;
  letter-spacing: 2px;
}


.bannerbox {
  text-align: left;
}

.bannerbox .description {
  width: 70%;
  text-indent: 2em;
}

.number {
  font-size: 72px;
  font-weight: bold;
  color: white;
  margin-bottom: 20px;
  line-height: 1;
}

.title-section {
  margin-bottom: 20px;
}

.soil-title {
  font-size: 32px;
  font-weight: bold;
  color: white;
  margin: 0 0 8px 0;
}

.soil-subtitle {
  font-size: 18px;
  color: white;
  font-style: italic;
  margin: 0;
  opacity: 0.9;
}

.description {
  margin-bottom: 20px;
}

.description p {
  font-size: 16px;
  line-height: 1.6;
  color: white;
  margin: 0;
}

.features {
  position: relative;
}

.features p {
  position: absolute;
  top: 0;
  left: -40px;
  font-size: 20px;
  padding: 20px 40px 20px 100px;
  margin: 0;
  color: white;
  font-weight: bold;
  background-color: #56b4a780;
  border-radius: 4px;
  text-align: left;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 主要内容 */
.main-content {
  background: url('../assets/bg1.png') no-repeat center center;
  padding: 0px 0 30px;
  margin-bottom: -40px;
  position: relative;
}

.content-wrapper {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
}

.left-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.right-section {
  display: flex;
  width: 527px;
  flex-shrink: 0;
}

/* 侧边栏容器样式 */
.sidebar-container {
  display: flex;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  width: 100%;
}

/* 左侧导航栏 */
.nav-sidebar {
  width: 170px;
  background-color: #efefef;
  flex-shrink: 0;
}

.nav-sidebar .iconfont {
  padding: 10px;
  background-color: #ddd;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.nav-sidebar .nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: 100px;
  font-size: 20px;
  position: relative;
  transition: all 0.3s ease;
}

.nav-sidebar .nav-item:hover .iconfont {
  background-color: #422C27;
  color: #333;
  transform: scale(1.1);
}

.nav-sidebar .nav-item.active .iconfont {
  background-color: #422C27;
  color: white;
  box-shadow: 0 4px 12px rgba(139, 111, 71, 0.4);
}

.nav-sidebar .nav-item:hover {
  background: linear-gradient(135deg, rgba(139, 111, 71, 0.1) 0%, rgba(139, 111, 71, 0.05) 100%);
  color: #422C27;
  transform: translateX(-5px);
  box-shadow: -8px 3px 15px rgba(139, 111, 71, 0.3);
}

.nav-sidebar .nav-item.active {
  background: linear-gradient(90deg, #fff 0%, rgba(139, 111, 71, 0.08) 100%);
  color: #422C27;
  font-weight: bold;
  box-shadow: -8px 3px 15px rgba(139, 111, 71, 0.4);
  border-left: 4px solid #422C27;
}


.nav-sidebar .nav-text {
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.nav-sidebar .nav-item:hover .nav-text {
  font-weight: bold;
  letter-spacing: 1px;
}

.nav-sidebar .nav-item.active .nav-text {
  font-weight: bold;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px 20px;
  cursor: pointer;
  transition: all 0.3s;
  border-left: 3px solid transparent;
}

.nav-item:hover,
.nav-item.active {
  background-color: #422C27;
  color: #fff
}

.nav-icon {
  font-size: 18px;
  width: 20px;
  text-align: center;
}

.option-item {
  font-size: 18px;
  width: auto;
  display: inline-block;
  padding-right: 10px;
}

/* 右侧内容面板 */
.content-panel {
  flex: 1;
  padding: 0;
  height: 400px;
  width: 100%;
  overflow: hidden;
}

.content-section {
  height: 100%;
  width: 100%;
  padding: 5px 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* 筛选区域 */
.filter-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 0;
  width: 100%;
}

/* 横向筛选组样式 */
.horizontal-filter-group {
  width: 100%;
  background: white;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 12px;
}

.filter-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  /* border-bottom: 1px solid #f0f0f0; */
  padding-bottom: 10px;
}

.filter-row:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.filter-label {
  flex-shrink: 0;
  width: 90px;
  font-size: 16px;
  color: #333;
  font-weight: 500;
  line-height: 32px;
  text-align: left;
}

.filter-options {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.filter-option {
  display: inline-block;
  padding: 5px 14px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 15px;
  color: #666;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.filter-option:hover {

  color: #333;
  background: #E4CEC2;
}

.filter-option.active {
  border-color: #422C27;
  background: #422C27;
  color: white;
  font-weight: 500;
}

.filter-input {
  flex: 1;
  max-width: 300px;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.filter-input:focus {
  outline: none;
  border-color: #422C27;
  background-color: #f0faf8;
}

.filter-input:hover {
  border-color: #422C27;
}

.filter-group {
  display: flex;
  gap: 0;
  width: 100%;
  max-width: 800px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
  border: 2px solid #e8e8e8;
}

.filter-select {
  flex: 1;
  height: 56px;
  min-width: 0;
  padding: 12px 35px 12px 16px;
  font-size: 15px;
  border: none;
  border-right: 1px solid #e8e8e8;
  background-color: white;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%230E8575' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px;
  appearance: none;
  cursor: pointer;
  color: #333;
  font-weight: 500;
  transition: all 0.3s ease;
}

.filter-select:last-child {
  border-right: none;
}

.filter-select:hover {
  background-color: #f8fffe;
  color: #422C27;
}

.filter-select:focus {
  outline: none;
  background-color: #f0faf8;
  color: #422C27;
}

.filter-select option {
  padding: 10px;
  color: #333;
  background: white;
}

.filter-select-first {
  border-radius: 8px 0 0 8px;
}

.filter-select-last {
  border-radius: 0 8px 8px 0;
}

/* 典型案例展示区域样式 */
.case-showcase-grid {
  display: flex;
  gap: 20px;
}

.case-showcase-item {
  flex: 1;
  background: #FFFFFF;
  border-radius: 8px 8px 30px 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border 0.3s ease;
  border: 2px solid transparent;
}

.case-showcase-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border: 2px solid #422C27;
}

.case-showcase-item:hover .case-showcase-action-btn {
  background-color: #422C27;
  color: #FFFFFF;
  transform: scale(1.05);
}

.case-showcase-image-container {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.case-showcase-image {  
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sold-stamp {
  position: absolute;
 top: -20px;
    left: -7px;
  z-index: 10;
  transform: rotate(-15deg);
}

.stamp-circle {
  width: 80px;
  height: 80px;
  border: 3px solid #ff0000;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.stamp-circle::before {
  content: '';
  position: absolute;
  top: -20px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  border: 1px solid #ff0000;
  border-radius: 50%;
  opacity: 0.5;
}

.stamp-text {
  color: #ff0000;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 2px;
  text-shadow: 0 0 2px rgba(255, 0, 0, 0.5);
}

.case-showcase-image-container {
  position: relative;
}

.case-showcase-content {
  position: relative;
  padding: 20px;
  position: relative;
  text-align: left;
}

.case-showcase-title {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 12px;
  line-height: 1.4;
}

.case-showcase-details {

  margin-bottom: 15px;
}

.case-showcase-cost {
  font-size: 14px;
  color: #422C27;
  margin-bottom: 8px;
}

.case-showcase-price {
  color: #FF0000;
  font-weight: 600;
}

.case-showcase-application {
  font-size: 14px;
  color: #422C27;
  line-height: 1.3;
}

.case-showcase-application-text {
  display: inline-block;
  width: 60px;
  text-align: justify;
  text-align-last: justify;
}

.case-showcase-action-btn {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 80px;
  height: 50px;
  border: none;
  border-radius: 30px 0 30px 0px;
  background-color: #E0E0E0;
  color: #666666;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}



/* 中间卡片的特殊样式（高亮状态）
.case-showcase-item:nth-child(2) .case-showcase-action-btn {
  background-color: #422C27;
  color: #FFFFFF;
} */

/* 新闻中心样式 */
.news-center-section {
  padding: 30px 0 40px 0;
  background: url(../assets/bg2.png) no-repeat center center;
  background-size: cover;
  position: relative;
  height: 420px;
}

.news-center-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 200px;
  height: 200px;
  background: linear-gradient(45deg, rgba(12, 108, 84, 0.1), transparent);
  border-radius: 0 0 100% 0;
}

.news-center-section::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 200px;
  height: 200px;
  background: linear-gradient(225deg, rgba(12, 108, 84, 0.1), transparent);
  border-radius: 100% 0 0 0;
}

.news-center-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0px;
}

/* Tab切换样式 */
.tab-container {
  display: flex;
  gap: 40px;
  align-items: center;
  position: relative;
  padding-left: 0;
}

.tab-item {
  padding: 5px 0;
  font-size: 18px;
  color: #666;
  background: none;
  border: none;
  cursor: pointer;
  position: relative;
  transition: color 0.3s;
}

.tab-item:hover {
  color: #422C27;
}

.tab-item-active {
  color: #422C27;
  font-weight: 600;
}

.tab-item-active::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 3px;
  background: #422C27;
  border-radius: 3px;
}

.news-center-title {
  display: flex;
  align-items: center;
  gap: 15px;
}

.news-center-main-title {
  font-size: 36px;
  font-weight: bold;
  color: #422C27;
  margin: 0;
  letter-spacing: 2px;
}

.news-center-subtitle {
  font-size: 16px;
  color: #999999;
  font-weight: 400;
}

.news-center-tabs {
  display: flex;
  gap: 10px;
}

.news-tab {
  padding: 12px 20px;
  border: 2px solid #422C27;
  background: white;
  color: #422C27;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.news-tab-active {
  background: #422C27;
  color: white;
}

.hangye {
  background: #004e95;
  color: white;
}

.hangye1 {
  background: #422C27;
  color: white;
}

.news-tab:hover {
  box-shadow: 0 4px 12px rgba(12, 108, 84, 0.3);
  transform: translateY(-2px);
}

.hangye:hover {
  box-shadow: 0 4px 12px rgba(0, 78, 149, 0.3);
  transform: translateY(-2px);
}

.news-center-content {
  display: flex;
  // gap: 30px;
  height: 100%;
}

.news-center-featured {
  flex: 1;
  position: relative;
  width: 49%;
  height: 100%;
  overflow: hidden;
  padding-left: 10px;
  // margin-left: 30px;
  // border-radius: 12px;
  // overflow: hidden;
  // box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.news-center-main-image {
  width: 100%;
  height: 100%;
  // object-fit: cover;
}

.news-center-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(#422C27a1, rgba(12, 108, 84, 0.8));
  padding: 30px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.news-center-date {
  flex-shrink: 0;
  text-align: center;
}

.news-center-day {
  font-size: 24px;
  font-weight: bold;
  color: white;
  line-height: 1;
}

.news-center-month {
  font-size: 14px;
  color: white;
  margin-top: 5px;
}

.news-center-featured-title {
  font-size: 18px;
  font-weight: 600;
  color: white;
  line-height: 1.4;
}

.news-center-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 49%;
  height: 100%;
}

.news-center-item {
  padding:0 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}
.news-center-item-title{
  padding: 10px 0;
}

.news-center-item:hover {
  background-color: rgba(12, 108, 84, 0.05);
}

.news-center-item:hover  {
  
  color: #333;
  background-color: #E4CEC2;
}

.news-center-item:last-child {
  border-bottom: none;
}

.news-center-item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: #333;
}

.news-center-item-title {
  width:80%;
  font-weight: normal;
  color: #333;
  margin: 0;
  line-height: 1.6;
  text-align: left;
  transition: color 0.3s ease;
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news-center-item-date-text {
  font-size: 16px;
  color: #666;
  margin-left: 20px;
  white-space: nowrap;
}

/* 页脚样式 */
.site-footer {
  margin-top: 10px;
}

.footer-categories {
  background-color: #422C27;
  padding: 15px 0;
}

.categories-bar {
  display: flex;
  align-items: center;
  gap: 20px;
}

.category-icon {
  color: white;
  font-size: 25px;
  margin-right: -14px;
}

.category-label {
  color: white;
  font-size: 14px;
  font-weight: 500;
}

.category-link {
  color: white;
  text-decoration: none;
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.category-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.footer-main {
  background-color: #4a4a4a;
  padding: 20px 0;
}

.footer-content {
  display: flex;
  gap: 60px;
  align-items: flex-start;
}

.footer-left {
  display: flex;
  flex-shrink: 0;
  .footermain{
    margin-left: 280px;
    font-size: 14px;
    color:#fff;
    div{
      margin-bottom: 10px;
    }
  }
}

.footer-logo {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  .logo1 img{
    width: 120px;
  }
  .logo2{
    padding-top: 10px;
    color:#fff;
    font-size: 18px;
    font-weight: bold;
  }
  .logo2 img{
    width: 30px;
    margin-top: 10px;
  }
}

.logo-text {
  color: white;
  font-size: 18px;
  font-weight: bold;
  margin-right: 10px;
}

.logo-chinese {
  color: white;
  font-size: 16px;
}

.footer-qr {
  text-align: center;
}

.qr-code {
  width: 120px;
  height: 120px;
  background-color: white;
  border: 2px solid white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.qr-placeholder {
  color: #4a4a4a;
  font-size: 12px;
  font-weight: bold;
}

.qr-text {
  color: white;
  font-size: 14px;
  margin: 0;
}

.footer-nav {
  display: flex;
  gap: 40px;
  flex: 1;
}

.nav-column {
  flex: 1;
}

.nav-title {
  color: white;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 20px 0;
}

.nav-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-links li {
  margin-bottom: 12px;
}

.nav-links a {
  color: white;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
}

.nav-links a:hover {
  color: #422C27;
}

.search-start-btn {
  width: 100%;
  max-width: 180px;
  height: 42px;
  line-height: 42px;
  background:  #381E1D;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 15px;
  font-weight: bold;
  box-shadow: 0 3px 10px rgba(139, 111, 71, 0.3);
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  text-align: center;
}

.search-start-btn:hover {
  background:#E4CEC2;
  box-shadow: 0 6px 16px rgba(139, 111, 71, 0.4);
  transform: translateY(-2px);
  color:#333;
}

.search-start-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(139, 111, 71, 0.3);
}

/* 内容列布局 */
.content-columns {
  display: none;
}

.content-column {
  flex: 1;
}

.column-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
  text-align: left;
}

.option-grid {
  margin-bottom: 15px;
  text-align: left;
}

.tab-content {
  display: none;
}

.option-item:hover {
  color: #422C27;
  transform: translateY(-2px);
}

/* 发布信息表单特殊样式 */
.publish-form {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.publish-form .form-select {
  width: 100%;
  margin-bottom: 10px;
}

.publish-form .form-group {
  width: 100%;
}

.form-title {
  font-size: 15px;
  color: #2c3e50;
  margin: 0 0 12px 0;
  font-weight: 500;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
}

.form-group1 {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 20px;
}

.form-group1 .form-field {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  width: 45%;
  flex-shrink: 0;
}

.form-group1 .form-field .form-input,
.form-group1 .form-field .form-select {
  padding: 13px;
  width: 100%;
  height: 45px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-group1 .form-field label {
  width: 80px;
  text-align: right;
  font-size: 14px;
  color: #2c3e50;
  flex-shrink: 0;
}

.form-select {
  padding: 12px 35px 12px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
  height: 45px;
  box-sizing: border-box;
  background-color: white;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%230E8575' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px;
  appearance: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.form-select:hover {
  border-color: #422C27;
  background-color: #f8fffe;
}

.form-select:focus {
  outline: none;
  border-color: #422C27 !important;
  background-color: #f0faf8;
  box-shadow: 0 0 0 3px rgba(139, 111, 71, 0.1) !important;
}

.publish-btn {
  width: 100%;
  max-width: 180px;
  height: 42px;
  line-height: 42px;
  background: linear-gradient(135deg, #E4CEC2 0%, #5C3D2E 100%);
  color: white;
  border: none;
  padding: 0;
  border-radius: 6px;
  cursor: pointer;
  font-size: 15px;
  font-weight: bold;
  box-shadow: 0 3px 10px rgba(139, 111, 71, 0.3);
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  margin: 0 auto;
  display: block;
}

.publish-btn:hover {
  background: linear-gradient(135deg, #6B5138 0%, #4A3528 100%);
  box-shadow: 0 6px 16px rgba(139, 111, 71, 0.4);
  transform: translateY(-2px);
}

.publish-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(139, 111, 71, 0.3);
}

/* 土评估表单 */
.evaluate-form {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
}

.form-reminder {
  color: #2c3e50;
  margin: 0 0 12px 0;
  font-size: 15px;
}

.form-field {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.form-field label {
  width: 80px;
  text-align: right;
  font-size: 14px;
  color: #2c3e50;
}

.form-input {
  padding: 13px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
  height: 45px;
  box-sizing: border-box;
}

/* 轮播图样式 */
.carousel-section {
  width: 100% !important;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: 400px;
}

.carousel-container {
  position: relative;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;
}

.carousel-wrapper {
  display: flex;
  height: 100%;
  transition: transform 0.5s ease-in-out;
}

.carousel-slide {
  min-width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slide-content {
  text-align: center;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.slide-image {
  margin-bottom: 20px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-img {
  max-width: 100%;
  object-fit: contain;
  border-radius: 8px;
}

/* 服务流程区域样式 */
.service-process-section {
  background: linear-gradient(135deg, #E4CEC2 0%, #5C3D2E 100%);
  padding: 60px 0;
  position: relative;
  overflow: hidden;
}

.service-process-section::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50%;
  background: linear-gradient(45deg, rgba(139, 111, 71, 0.1) 0%, rgba(139, 111, 71, 0.05) 100%);
  opacity: 0.3;
}

.process-header {
  text-align: left;
  margin-bottom: 50px;
  position: relative;
  z-index: 2;
  display: flex;
}

.process-title {
  font-size: 24px;
  font-weight: bold;
  color: white;
  margin: 0 0 10px 0;
  letter-spacing: 2px;
}

.process-subtitle {
  margin-left: 20px;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  text-align: left;
}

.flow-text {
  display: inline-block;
  font-size: 14px;
  color: #3d3d3d;
}

.chinese-text {
  font-size: 20px;
  color: white;
  font-weight: 500;
}

.process-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
  position: relative;
  z-index: 2;
  max-width: 1400px;
  margin: 0 auto;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-width: 150px;
}

.step-icon {
  width: 90px;
  height: 90px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
}

.step-icon:hover {
  transform: scale(1.1);
}

.step-icon .iconfont {
  font-size: 38px;
  color: #422C27;
}

.step-text {
  font-size: 18px;
  color: white;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  white-space: nowrap;
}

.step-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 20px;
  flex-shrink: 0;
}

.step-arrow .iconfont {
  font-size: 26px;
  color: #E4CEC2;
}

.contact-button {
  margin-left: 30px;
}

.contact-btn {
  background-color: white;
  color: #422C27;
  border: none;
  padding: 15px 30px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.contact-btn:hover {
  background-color: rgba(255, 255, 255, 0.9);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.contact-btn .iconfont {
  font-size: 14px;
}

/* 水保资讯模块样式 */
.service-info-section {
  background: rgba(14, 130, 116, 0.04);
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.hot-categories-section {
  background: #fff;
  padding: 20px;
  margin-bottom: 30px;
}

.service-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;

}

.service-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-bar {
  width: 10px;
  height: 40px;
  background-color: #422C27;
  border-radius: 2px;
}

.main-title {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.subtitle {
  font-size: 20px;
  color: #666;
  margin-left: 10px;
}

.view-all-link {
  color: #422C27;
  text-decoration: none;
  font-size: 14px;
}

.view-all-link:hover {
  text-decoration: underline;
}

.service-content {
  display: flex;
  gap: 20px;
}

.service-image {
  flex: 1;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

.main-image {
  width: 520px;
  height: 330px;
  object-fit: cover;
  border-radius: 8px;
}

.image-tag {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: #e74c3c;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
}

.news-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.news-item {
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  text-align: left;
}

.news-item:last-child {
  border-bottom: none;
}

.news-title {
  font-size: 22px;
  color: #333;
  margin: 0 0 5px 0;
  line-height: 1.4;
  cursor: pointer;
}

.news-title:hover {
  color: #422C27;
}

.news-date {
  font-size: 12px;
  color: #999;
}

/* 热门分类 */
.hot-categories {
  width: 100%;
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;

}

.categories-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;

}

.categories-title-section {
  display: flex;
  align-items: center;
  gap: 10px;
}

.categories-title {
  color: #2c3e50;
  font-size: 36px;
  margin: 0;
  font-weight: bold;
}

.categories-tabs {
  display: flex;
  gap: 20px;
  margin-left: 20px;
}

.category-tab {
  color: #666;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  font-size: 24px;
}

.category-tab.active {
  color: #422C27;
  font-weight: bold;
  background: linear-gradient(135deg, rgba(139, 111, 71, 0.1) 0%, rgba(139, 111, 71, 0.1) 100%);
  border-radius: 8px;
  padding: 8px 16px;
  position: relative;
  transform: translateY(-2px);
}

.category-tab.active::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 3px;
  background: linear-gradient(90deg, #422C27, #E4CEC2);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(139, 111, 71, 0.3);
}

.category-tab:hover {
  color: #422C27;
}

.more-link {
  margin-left: auto;
  color: #999;
  text-decoration: none;
  font-size: 14px;
}

.more-link:hover {
  color: #422C27;
}

/* 产品网格 */
.products-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

.product-card {
  border: 1px solid #ecf0f1;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border: 2px solid #422C27;
}

.product-image {
  position: relative;
  height: 180px;
  overflow: hidden;
}

.product-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-tags {

  display: flex;
  gap: 5px;
}

.tag {
  margin-bottom: 20px;
}

.new-tag {
  width: 47px;
  height: 24px;
  background: rgba(255, 161, 0, 0.2);
  box-sizing: border-box;
  border: 1px solid rgba(255, 123, 0, 0.5);
  color: #FF7B00;
  font-size: 14px;
  border-radius: 4px;
  margin-left: 5px;
}

.transport-tag {
  width: 47px;
  height: 24px;
  background: rgba(0, 113, 215, 0.2);
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid rgba(0, 113, 215, 0.5);
  color: #0071D7;
  font-size: 14px;
}

.product-info {
  position: relative;
  padding: 15px;
}

.product-code {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
}

.price-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}



.product-volume {
  color: #999;
  font-size: 22px;
}

.product-location {
  color: #666;
  font-size: 22px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.location-icon {
  font-size: 14px;
}

/* 统一所有select的样式 */
select {
  background-color: white;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%230E8575' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px;
  appearance: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

select:hover {
  border-color: #422C27;
  background-color: #f8fffe;
}

select:focus {
  outline: none;
  border-color: #422C27;
  background-color: #f0faf8;
}

/* 统一所有input的焦点样式 */
input:focus,
.search-input:focus,
.search-dropdown:focus,
.form-input:focus {
  outline: none !important;
  border-color: #d8d8d8 !important;
  box-shadow: none !important;
}

/* 确保所有input的默认状态 */
input,
.search-input,
.search-dropdown,
.form-input {
  border-color: #d8d8d8 !important;
}

/* input悬停状态 */
input:hover,
.search-input:hover,
.search-dropdown:hover,
.form-input:hover {
  border-color: #d8d8d8 !important;
}

/* input选中状态 */
input:active,
.search-input:active,
.search-dropdown:active,
.form-input:active {
  border-color: #d8d8d8 !important;
}

.flow-icon {
  width: 100px;
  height: 100px;
  background-color: #422C27;
  border-radius: 50%;
  line-height: 100px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-buttons {
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
  }
  
  .test-btn {
    padding: 8px 16px;
    font-size: 12px;
  }
  
  .header-main-content {
    flex-direction: column;
    gap: 20px;
  }

  /* 服务流程样式 */
  .service-flow-section {
    padding: 20px;
    border-radius: 8px;
    margin-top: 20px;
  }

  .flow-container {
    position: relative;
    width: 100%;
    height: 320px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }

  .flow-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    text-align: center;
  }

  .flow-item.top-left {
    top: 0;
    left: 0;
  }

  .flow-item.top-right {
    top: 0;
    right: 0;
  }

  .flow-item.bottom-right {
    bottom: 0;
    right: 0;
  }

  .flow-item.bottom-left {
    bottom: 0;
    left: 0;
  }

  .flow-icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: #422C27;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    box-shadow: 0 4px 12px rgba(12, 106, 86, 0.2);
  }

  .flow-img {
    width: 50px;
    height: 50px;
    object-fit: contain;
  }



  .flow-arrow {
    position: absolute;
    font-size: 24px;
    color: #422C27;
  }

  .flow-arrow.horizontal {
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
    width: 40%;
    text-align: center;
  }

  .flow-arrow.horizontal.reverse {
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    width: 40%;
    text-align: center;
  }

  .flow-arrow.vertical {
    right: 40px;
    top: 50%;
    transform: translateY(-50%);
    height: 40%;
    display: flex;
    align-items: center;
  }

  /* 响应式设计 */
  @media (max-width: 768px) {
    .flow-container {
      height: 280px;
    }

    .flow-icon {
      width: 60px;
      height: 60px;
    }

    .flow-img {
      width: 35px;
      height: 35px;
    }

    .flow-text {
      font-size: 12px;
      width: 100px;
    }
  }

  .search-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .search-input-group {
    flex-direction: column;
  }

  .search-input {
    border-radius: 4px;
    margin-bottom: 10px;
  }

  .search-btn {
    border-radius: 4px;
  }

  .content-wrapper {
    flex-direction: column;
  }

  .products-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .nav-list {
    flex-wrap: wrap;
  }

  .nav-item {
    padding: 10px 15px;
  }
}

@media (max-width: 480px) {
  .products-grid {
    grid-template-columns: 1fr;
  }

  .categories-list {
    flex-wrap: wrap;
  }
}

.service-flow-section {
  padding: 40px 0;

  .iconfont {
    font-size: 48px;
    color: #422C27;
  }
}

.serve-flow-item {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.serve-flow-item>div {
  width: 180px;
  flex-shrink: 0;
}

.serve-flow-item>div:nth-child(2) {
  width: 50px;
  flex-shrink: 0;
}

.flow-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 40px;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  margin-left: 20px;
}

.flow-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.flow-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  margin-bottom: 10px;
  background-color: #422C27;
  border-radius: 50%;
  line-height: 100px;
}

.flow-icon-emoji {
  display: flex;
  font-size: 48px;
  text-align: center;
}
.iconfontright{
  text-align: right;
    margin-right: 70px;
    margin-top: -20px;
    height: 20px;
}

/* 鼠标划过样式 */
.hover-effect {
  transition: all 0.3s ease;
  cursor: pointer;
}

.hover-effect:hover {
  transform: translateY(-5px);
}

.hover-effect:hover .flow-icon {
  background-color: #E4CEC2;
   color: #333;
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(12, 106, 86, 0.3);
}

.hover-effect:hover .flow-text {
  color: #422C27;
  font-weight: 500;
}

.flow-icon {
  transition: all 0.3s ease;
}

.flow-text {
  transition: color 0.3s ease;
}

/* 图标划过效果 */
.hover-icon {
  transition: all 0.3s ease;
  transform-origin: center;
}

.hover-icon:hover {
  transform: scale(1.2);
  color: #0a5a48;
}


/* 响应式设计 */
@media (max-width: 768px) {
  .flow-grid {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, auto);
    gap: 30px;
  }

  .flow-icon {
    width: 80px;
    height: 80px;
  }

  .flow-icon-emoji {
    font-size: 36px;
  }

  .flow-text {
    font-size: 14px;
  }
}
.view-all{
  text-align: right;
  color:#422C27;
  cursor: pointer;
    font-size: 16px;
}
.view-all:hover {
  text-decoration: underline;
}

/* 发布弹窗样式 */
.publish-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  overflow-y: auto;
}

.publish-modal-container {
  background: #fff;
  border-radius: 8px;
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  margin: 20px auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  position: relative;
}

.publish-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
  background: #f8f8f8;
  border-radius: 8px 8px 0 0;
}

.publish-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.publish-modal-header .close-btn {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.3s;
}

.publish-modal-header .close-btn:hover {
  background: #eee;
  color: #333;
}

.publish-modal-content {
  flex: 1;
  overflow-y: auto;
  padding: 0;
}

.publish-modal-content .land-supply-page {
  padding: 0;
}

.publish-modal-content .container {
  padding: 20px 24px;
}
.qtzp-logo{
  width: 120px;
  height: 20px;
  margin-top: 8px;
}
.footermain-item a{
  color: #1890ff;
  text-decoration: underline;
}
</style>
